exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".important-info{border:1px solid #444;padding:20px;margin-top:25px;border-radius:4px}.important-info .heading{border-radius:4px;background:#333;color:#fff;padding:20px}.important-info .description{padding:20px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/BringYourOwnModem/ImportantInfo.scss
 ** module id = 1207
 ** module chunks = 0
 **/